import { ActionReducer } from '@ngrx/store';

import { LocalStorageConfig, localStorageSync } from 'ngrx-store-localstorage';
import { ApplicationState } from 'state';

export type StoreKey = keyof ApplicationState;
interface ExtendedLocalStorageConfig extends LocalStorageConfig {
    keys: StoreKey[]; // type-safe strings
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    const keys: ExtendedLocalStorageConfig = {
        keys: ['token', 'functionality', 'authentication', 'user', 'organisation', 'oauth']
    };
    return localStorageSync(keys)(reducer);
}
